import { todayUpdates } from '@/mocks/animeData';
import ComicCard from './ComicCard';

export default function TodayUpdates() {
  return (
    <section id="today" className="scroll-mt-20 px-4 py-12 md:px-6 md:py-16">
      <div className="mx-auto max-w-6xl">
        <div className="mb-6 flex flex-wrap items-center justify-between gap-3">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-950">
              今日更新
            </h2>
            <p className="mt-1 text-sm text-foreground-600">
              热播连载的最新话已上线，第一时间跟上追更进度
            </p>
          </div>
          <a
            href="#ranking"
            className="inline-flex items-center gap-1 text-sm font-medium text-primary-600 hover:text-primary-700"
          >
            查看完整榜单 <i className="ri-arrow-right-line"></i>
          </a>
        </div>

        <div className="grid grid-cols-2 gap-3 md:gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {todayUpdates.map((comic) => (
            <ComicCard key={comic.id} comic={comic} />
          ))}
        </div>
      </div>
    </section>
  );
}